/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Realtime Schema Projection
 * Frontend-only aliases for realtime payload validation.
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {RealtimeResourceChange} from "./realtimeResourceChange.zod";
import {ServiceFunctionId} from "./serviceFunctionId.zod";

export const ServiceFunctionRealtimeChange = RealtimeResourceChange.and(
  zod.object({
    resource: zod.enum(["engineering.service-functions"]),
    resourceId: ServiceFunctionId,
    change: zod.enum(["CREATED", "UPDATED", "DELETED", "RESTORED"]),
  }),
);

export type ServiceFunctionRealtimeChange = zod.input<typeof ServiceFunctionRealtimeChange>;
export type ServiceFunctionRealtimeChangeOutput = zod.output<typeof ServiceFunctionRealtimeChange>;
